import { useEffect, useState } from "react";
import axios from "axios";
import TopBar from "./TopBar";

function MainLayout({ children }) {

  const [user, setUser] = useState(null);

  useEffect(() => {

    getProfile();

  }, []);

  const getProfile = async () => {

    try {

      const token = localStorage.getItem("token");

      const response = await axios.get(
        "https://saleupcall.com/api/profile.php",
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      if(response.data.status){

        setUser(response.data.user);

      }

    }
    catch(error){

      console.log(error);

    }

  };

  const logout = () => {

    localStorage.removeItem("token");
    localStorage.removeItem("role_id");

    window.location.href="/";

  };

  return(
    <>
<TopBar title="Tickets"/>
    <div>

      {/* Sidebar */}

      <div
      style={{
        width:"220px",
        height:"100vh",
        background:"#ddd",
        float:"left",
        padding:"20px"
      }}
      >
        <p>

          <a href="/">
            Dashboard
          </a>

        </p>

        {
          user?.role_id == 1 && (

            <>

            <p><a href="/Tickets">Tickets</a></p>

<p>
  <a href="/clients">Clients</a>
</p>

<p>
  <a href="/Managers">Managers</a>
</p>
<p>
  <a href="/Designations">Designations</a>
</p>

<p>
  <a href="/Departments">Departments</a>
</p>

<p>
  <a href="/Technicians">Technicians</a>
</p>

      </>

          )
        }

        {
          user?.role_id == 3 && (
            <>
            <p><a href="/assigned-jobs">Assigned Jobs</a></p>
            </>
          )
        }
         {
          user?.role_id == 4 && (
            <>
               <p><a href="/Tickets">Tickets</a></p>
            </>
          )
        }

      </div>

      {/* Content */}

      <div
      style={{
        marginLeft:"240px",
        padding:"20px"
      }}
      >

        {children}

      </div>

    </div>
</>
  );

}

export default MainLayout;